export const isWindowExists = () => {
    return typeof window != 'undefined';
}

export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}